export const NAME = 'project';
export const PROJECT_FORM_NAME = 'projectForm';
export const INVITE_FORM_NAME = 'inviteForm';
export const PROJECT_SETTINGS_FORM_NAME = 'projectSettingsForm';
